import axios from '../api/axiosInstance';

export const fetchMenuSections = (shopId) => axios.get(`/shops/${shopId}/menu-sections`);

export const createMenuSection = (shopId, data) => axios.post(`/shops/${shopId}/menu-sections`, data);

export const updateMenuSection = (shopId, menuSectionId, data) =>
  axios.patch(`/shops/${shopId}/menu-sections/${menuSectionId}`, data);

export const deleteMenuSection = (shopId, menuSectionId) =>
  axios.delete(`/shops/${shopId}/menu-sections/${menuSectionId}`);

export const getMenuSection = (shopId, menuSectionId) =>
  axios.get(`/shops/${shopId}/menu-sections/${menuSectionId}`);

export const fetchMenuSectionProducts = (shopId, menuSectionId) =>
  axios.get(`/shops/${shopId}/menu-sections/${menuSectionId}/products`);

export const updateMenuSectionProducts = (shopId, menuSectionId, productIds) =>
  axios.put(`/shops/${shopId}/menu-sections/${menuSectionId}/products`, { productIds });
